module.exports = __webpack_public_path__ + "assets/img/13.a909962d.png";